import type { CSSProperties } from "react";
import { heyLife } from "@heylife/ui-tokens";

type MarkProps = { height?: number; duotone?: boolean; color?: string; style?: CSSProperties; className?: string };

/** The Hey Life mark (H with an L foot). `duotone` paints the L coral. Fills with currentColor. */
export function HeyLifeMark({ height = 24, duotone = false, color, style, className }: MarkProps) {
  const { mark, markL } = heyLife;
  const width = (height * mark.w) / mark.h;
  return (
    <svg role="img" aria-label="Hey Life" width={width} height={height} viewBox={`0 0 ${mark.w} ${mark.h}`} className={className} style={{ display: "block", flex: "none", color, ...style }}>
      <path d={mark.d} fill="currentColor" />
      {duotone ? <path d={markL.d} fill={heyLife.tile.field} /> : null}
    </svg>
  );
}

/** Horizontal lockup: mark on the cap line, then the Figtree Bold wordmark. */
export function HeyLifeLogo({ height = 28, duotone = false, color, style, className }: MarkProps) {
  const { lockup, mark, markL, wordmark } = heyLife;
  const width = (height * lockup.w) / lockup.h;
  return (
    <svg role="img" aria-label="Hey Life" width={width} height={height} viewBox={`0 0 ${lockup.w} ${lockup.h}`} className={className} style={{ display: "block", flex: "none", color, ...style }}>
      <g transform={`translate(0 ${lockup.markY}) scale(${lockup.markScale})`}>
        <path d={mark.d} fill="currentColor" />
        {duotone ? <path d={markL.d} fill={heyLife.tile.field} /> : null}
      </g>
      <g transform={`translate(${lockup.wordX} 0)`}>
        <path d={wordmark.d} fill="currentColor" />
      </g>
    </svg>
  );
}

/** The prototype's welcome tile: coral square, paper mark. */
export function HeyLifeTile({ size = 44, style }: { size?: number; style?: CSSProperties }) {
  const { mark, tile } = heyLife;
  const mw = size * tile.markWidth;
  const mh = (mw * mark.h) / mark.w;
  return (
    <svg role="img" aria-label="Hey Life" width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ display: "block", flex: "none", ...style }}>
      <rect width={size} height={size} rx={size * tile.radius} fill={tile.field} />
      <g transform={`translate(${(size - mw) / 2} ${(size - mh) / 2}) scale(${mw / mark.w})`}>
        <path d={mark.d} fill={tile.ink} />
      </g>
    </svg>
  );
}
